import { isEmpty, isNil, isNumber } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Statuses from '../../../../model/Statuses';
import withOrganisationStructures from '../../../data/withOrganisationStructures';
import { RETURN_TYPE } from '../base/SelectBox';
import SelectBox from '../base/SelectBox/SelectBox';
import ValueView from '../ValueViews/ValueView';
import SelectBoxFilter from './SelectBoxFilter';

@withOrganisationStructures({
  options: ({ orgGroupId, status }) => ({
    skip: isNil(orgGroupId),
    variables: {
      status,
      orgGroupId,
      count: 100,
    },
  }),
  passLoader: false,
})
export default class OrganisationStructuresSelector extends React.PureComponent {
  static propTypes = {
    orgGroupId: PropTypes.number.isRequired,
    label: PropTypes.string,
    status: PropTypes.string,
    editable: PropTypes.bool,
    returnType: PropTypes.oneOf(Object.values(RETURN_TYPE)),
    input: PropTypes.object,
    meta: PropTypes.object,
    itemValuePropName: PropTypes.string,
    onOrgStructSelectionChange: PropTypes.func,
    filter: PropTypes.object,
    isFilterBar: PropTypes.bool,
  };

  static defaultProps = {
    isFilterBar: true,
    status: Statuses.Active.value,
    returnType: RETURN_TYPE.NUMBER,
    editable: true,
    input: {},
    meta: {},
    itemValuePropName: 'id',
    onOrgStructSelectionChange: null,
    filter: {},
    label: '',
  };

  state = {
    currValue: '',
  };

  componentDidMount() {
    const {
      filter: { organisationStructure } = {},
      organisationStructures,
      onOrgStructSelectionChange,
    } = this.props;
    if (isEmpty(organisationStructure) && !isEmpty(organisationStructures)) {
      onOrgStructSelectionChange &&
        onOrgStructSelectionChange(organisationStructures[0]);
    }
  }

  get viewValue() {
    const { organisationStructures = [], value } = this.props;
    return organisationStructures.find(
      item => item === value || item.id === value,
    );
  }

  get editComponent() {
    const {
      isFilterBar,
      organisationStructures,
      label,
      editable,
      meta: { submitting, touched, error, submitFailed } = {},
      loading,
      value,
      ...rest
    } = this.props;

    const currValue =
      value &&
      !isNumber(value) &&
      !isEmpty(organisationStructures) &&
      organisationStructures.find(item => item === value || item.id === value);

    if (currValue) this.setState({ currValue });

    const placeholder = loading ? 'loading...' : label;

    if (isFilterBar) {
      return (
        <SelectBoxFilter
          disabled={submitting || loading}
          errorMessage={((touched || submitFailed) && error) || null}
          itemValuePropName="id"
          options={organisationStructures}
          placeholder={placeholder}
          value={this.state.currValue}
          {...rest}
        />
      );
    }

    return (
      <SelectBox
        disabled={submitting || loading}
        errorMessage={((touched || submitFailed) && error) || null}
        itemValuePropName="id"
        options={organisationStructures}
        placeholder={placeholder}
        value={value}
        {...rest}
      />
    );
  }

  render() {
    const { label, editable } = this.props;

    return editable ? (
      this.editComponent
    ) : (
      <ValueView label={label} value={this.viewValue?.name} />
    );
  }
}
